// src/config/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import zhTWCommon from '../locales/zh-TW/common.json';
import zhTWLanding from '../locales/zh-TW/landing.json';
import zhTWFeatures from '../locales/zh-TW/features.json';
import zhTWFaq from '../locales/zh-TW/faq.json';
import zhTWPricing from '../locales/zh-TW/pricing.json';
import zhTWAuth from '../locales/zh-TW/auth.json';
import zhTWLegal from '../locales/zh-TW/legal.json';  // 新增

import zhCNCommon from '../locales/zh-CN/common.json';
import zhCNLanding from '../locales/zh-CN/landing.json';
import zhCNFeatures from '../locales/zh-CN/features.json';
import zhCNFaq from '../locales/zh-CN/faq.json';
import zhCNPricing from '../locales/zh-CN/pricing.json';
import zhCNAuth from '../locales/zh-CN/auth.json';
import zhCNLegal from '../locales/zh-CN/legal.json';  // 新增

import enCommon from '../locales/en/common.json';
import enLanding from '../locales/en/landing.json';
import enFeatures from '../locales/en/features.json';
import enFaq from '../locales/en/faq.json';
import enPricing from '../locales/en/pricing.json';
import enAuth from '../locales/en/auth.json';
import enLegal from '../locales/en/legal.json';  // 新增

import jaCommon from '../locales/ja/common.json';
import jaLanding from '../locales/ja/landing.json';
import jaFeatures from '../locales/ja/features.json';
import jaFaq from '../locales/ja/faq.json';
import jaPricing from '../locales/ja/pricing.json';
import jaAuth from '../locales/ja/auth.json';
import jaLegal from '../locales/ja/legal.json';  // 新增

const resources = {
  'zh-TW': {
    common: zhTWCommon,
    landing: zhTWLanding,
    features: zhTWFeatures,
    faq: zhTWFaq,
    pricing: zhTWPricing,
    auth: zhTWAuth,
    legal: zhTWLegal  // 新增
  },
  'zh-CN': {
    common: zhCNCommon,
    landing: zhCNLanding,
    features: zhCNFeatures,
    faq: zhCNFaq,
    pricing: zhCNPricing,
    auth: zhCNAuth,
    legal: zhCNLegal  // 新增
  },
  en: {
    common: enCommon,
    landing: enLanding,
    features: enFeatures,
    faq: enFaq,
    pricing: enPricing,
    auth: enAuth,
    legal: enLegal  // 新增
  },
  ja: {
    common: jaCommon,
    landing: jaLanding,
    features: jaFeatures,
    faq: jaFaq,
    pricing: jaPricing,
    auth: jaAuth,
    legal: jaLegal  // 新增
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-TW',
    defaultNS: 'common',
    ns: ['common', 'landing', 'features', 'faq', 'pricing', 'auth', 'legal'],  // 新增 'legal'
    
    detection: {
      // htmlTag（index.html 的 lang="zh-TW"）排在 navigator 前面：
      // prerender 的 headless 瀏覽器 navigator.language 是 en-US，
      // 會把首頁渲染成英文餵給 Google/爬蟲，傷害中文 SEO。
      // 改用 htmlTag 確保爬蟲與首次訪客預設拿到 zh-TW；
      // 使用者手動切換的語言仍會存進 localStorage/cookie（排在最前）而保留。
      order: ['localStorage', 'cookie', 'htmlTag', 'navigator'],
      caches: ['localStorage', 'cookie'],
    },
    
    interpolation: {
      escapeValue: false
    },
    
    react: {
      useSuspense: false
    }
  });

export default i18n;